(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Policy', Policy);

    Policy.$inject = ['$resource'];

    function Policy ($resource) {
        var resourceUrl =  'api/policies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'verify': {
                method: 'POST',
                url: 'api/verify-policy'
            },
            'create': {
                method: 'POST',
                url: 'api/create-policy'
            },
            'activate': {
                method: 'POST',
                url: 'api/activate-policy'
            }
        });
    }
})();
